<template>
  <!-- 스펙234_개선_17: [cafe24 주문 목록 검색 팝업] -->
  <div class="modal-mask" @click.self="$emit('close')">
    <div class="modal">
      <div class="modal-head">
        <h4 class="title">cafe24 주문 목록 검색 팝업</h4>
        <span class="spacer"></span>
        <button class="ghost" @click="$emit('close')">닫기</button>
      </div>

      <!-- 고객 검색 -->
      <div class="row">
        <span class="cust">{{ loginId ? (name || '') + '(' + loginId + ')' : '(고객 미선택)' }}</span>
        <button class="ghost" @click="memberOpen=true">검색</button>
      </div>

      <!-- 기간 + 주문 검색 -->
      <div class="row">
        <input v-model="startDt" type="date" :min="MIN_DT" />
        <span class="dash">~</span>
        <input v-model="endDt" type="date" :min="MIN_DT" />
        <span class="spacer"></span>
        <button class="primary" @click="searchOrders" :disabled="busy">{{ busy ? '검색 중…' : '주문 검색' }}</button>
      </div>

      <p v-if="msg" class="msg">{{ msg }}</p>

      <div class="table-scroll">
        <table class="grid">
          <thead><tr><th style="width:56px;">선택</th><th>주문번호</th></tr></thead>
          <tbody>
            <tr v-for="(o, i) in paged" :key="i" @click="picked = o">
              <td class="center"><input type="radio" :value="o" v-model="picked" @click.stop /></td>
              <td>{{ o }}</td>
            </tr>
            <tr v-if="list.length===0"><td colspan="2" class="empty">조회된 주문이 없습니다.</td></tr>
          </tbody>
        </table>
      </div>

      <Paging v-if="list.length > 0" :page="page" :size="size" :total-count="list.length" :total-pages="totalPages"
              @change-page="p => page = p" @change-size="s => { size = s; page = 1; }" />

      <div class="foot">
        <span class="spacer"></span>
        <button class="apply" @click="apply" :disabled="!picked">적용</button>
      </div>

      <!-- 회원 검색 팝업 -->
      <SearchDialog v-if="memberOpen" @select="onMember" @close="memberOpen=false" />
    </div>
  </div>
</template>

<script>
import api from '../api';
import SearchDialog from './SearchDialog.vue';
import Paging from './Paging.vue';

const MIN_DT = '2026-08-05';    // 선택 가능한 최소 시작일(2026-08-04 이하 불가) - 스펙234_개선_22

// 로컬 날짜(YYYY-MM-DD) 포맷
function fmt(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return y + '-' + m + '-' + dd;
}

export default {
  name: 'OrderListSearchDialog',
  components: { SearchDialog, Paging },
  data() {
    // 스펙234_개선_22: 진입 시 시작일 = 오늘로부터 85일전(2026-08-04 이하이면 강제로 2026-08-05), 종료일 = 오늘
    const today = new Date();
    const back = new Date(); back.setDate(back.getDate() - 85);
    let s = fmt(back);
    if (s <= '2026-08-04') s = MIN_DT;
    return { MIN_DT, loginId: '', name: '', startDt: s, endDt: fmt(today),
             list: [], picked: null, page: 1, size: 10, busy: false, msg: '', memberOpen: false };
  },
  computed: {
    totalPages() { return Math.max(1, Math.ceil(this.list.length / this.size)); },
    paged() { const s = (this.page - 1) * this.size; return this.list.slice(s, s + this.size); }
  },
  watch: {
    // 스펙234_개선_22: 시작일 캘린더에서 2026-08-04 이하 선택 시 안내 후 최소값으로 되돌림
    startDt(v) {
      if (v && v <= '2026-08-04') {
        this.msg = '2026년 8월 4일 이하 날짜는 선택할 수 없습니다';
        this.$nextTick(() => { this.startDt = MIN_DT; });
      }
    }
  },
  methods: {
    onMember(sel) { this.loginId = sel.loginId; this.name = sel.name; this.memberOpen = false; },
    monthsGap(a, b) {
      // a,b: 'YYYY-MM-DD'. 3개월(=대략 92일) 미만 여부 판단용 개월 차 근사
      const da = new Date(a), db = new Date(b);
      return (db.getFullYear() - da.getFullYear()) * 12 + (db.getMonth() - da.getMonth())
             + (db.getDate() >= da.getDate() ? 0 : -1);
    },
    async searchOrders() {
      if (this.busy) return;
      if (!this.loginId) { this.msg = '고객을 먼저 검색해서 선택하세요.'; return; }
      if (!this.startDt || !this.endDt) { this.msg = '시작일/종료일을 선택하세요.'; return; }
      if (this.startDt > this.endDt) { this.msg = '시작일이 종료일보다 클 수 없습니다.'; return; }
      if (this.startDt < MIN_DT) { this.msg = '시작일은 ' + MIN_DT + ' 이후여야 합니다.'; return; }
      if (this.monthsGap(this.startDt, this.endDt) >= 3) { this.msg = '기간은 3개월 미만이어야 합니다.'; return; }
      this.busy = true; this.msg = ''; this.picked = null;
      try {
        const res = await api.orderListSearch(this.loginId, this.startDt, this.endDt);
        this.list = res.data || [];
        this.page = 1;
        if (this.list.length === 0) this.msg = '조회된 주문이 없습니다.';
      } catch (e) {
        this.msg = (e && e.response && e.response.data && e.response.data.message) || e.message || '주문 검색 실패';
        this.list = [];
      } finally {
        this.busy = false;
      }
    },
    apply() {
      if (!this.picked) return;
      this.$emit('apply', this.picked);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.35); display: flex; align-items: center; justify-content: center; z-index: 70; }
.modal { background: #fff; border-radius: 10px; width: 520px; max-width: 92vw; max-height: 86vh; overflow: auto; padding: 12px 16px; }
.modal-head { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.modal-head .title { margin: 0; font-size: 15px; font-weight: 700; color: #263043; }
.row { display: flex; align-items: center; gap: 8px; margin: 6px 0; }
.row .spacer, .modal-head .spacer, .foot .spacer { flex: 1 1 auto; }
.row .cust { font-size: 13px; color: #33405c; }
.row input[type="date"] { height: 30px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 8px; }
.dash { color: #8a95ab; }
.msg { color: #c0392b; font-size: 13px; margin: 4px 0; }
.table-scroll { border: 1px solid #e4e9f2; border-radius: 8px; overflow: auto; max-height: 44vh; margin-top: 6px; }
.grid { width: 100%; border-collapse: collapse; font-size: 13px; }
.grid th, .grid td { border-bottom: 1px solid #e4e9f2; padding: 6px 8px; }
.grid thead th { background: #f2f5fb; color: #33405c; }
.grid td.center { text-align: center; }
.grid .empty { text-align: center; color: #8a95ab; padding: 16px; }
.foot { display: flex; align-items: center; margin-top: 10px; }
button { height: 30px; border-radius: 6px; padding: 0 14px; cursor: pointer; font-size: 13px; border: 1px solid #cfd6e6; background: #fff; color: #33405c; }
button.primary { background: #4d8bff; border-color: #4d8bff; color: #fff; }
button.apply { background: #1f9d55; border-color: #1f9d55; color: #fff; }
button:disabled { opacity: .55; cursor: default; }
</style>
